var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.templateId === "54ad5defc6454f065c28af8b"
      ? _c(
          "div",
          {
            staticClass: "trustpilot-widget",
            attrs: {
              "data-locale": "en-US",
              "data-template-id": "54ad5defc6454f065c28af8b",
              "data-businessunit-id": "62986c2d67f7ac096850d61c",
              "data-style-height": "240px",
              "data-style-width": "100%",
              "data-theme": "light",
              "data-stars": "4,5",
              "data-review-languages": "en"
            }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.trustpilot.com/review/shopvidi.com",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v("Trustpilot")]
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.templateId === "53aa8807dec7e10d38f59f32"
      ? _c(
          "div",
          {
            staticClass: "trustpilot-widget",
            attrs: {
              "data-locale": "en-US",
              "data-template-id": "53aa8807dec7e10d38f59f32",
              "data-businessunit-id": "62986c2d67f7ac096850d61c",
              "data-style-height": "110px",
              "data-style-width": "100%",
              "data-theme": "light"
            }
          },
          [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.trustpilot.com/review/shopvidi.com",
                  target: "_blank",
                  rel: "noopener"
                }
              },
              [_vm._v("Trustpilot")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-709f2fd4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709f2fd4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trustpilotWidget.vue
// module id = null
// module chunks = 